import {useForm, Controller} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {apiError, handleRequest} from "../../../../utils";
import {ticketApi} from "../../../../api";
import {Button, Loading} from "../../../../components";
import {EditorField, InputField} from "../../../../components/Forms";
import DOMPurify from "dompurify";
import {Card, Col, Row} from "antd";


function TicketFormComment({ticket, setComments, comments})
{
    const validationSchema = Yup.object().shape({
        comment: Yup.string().required('Bạn chưa điền câu trả lời'),
    })

    const initialValues = {
        comment: '',
        file1: null,
        file2: null,
        file3: null,
    }

    const { control, handleSubmit, formState: { isSubmitting, errors }, reset, setValue } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validationSchema)
    });

    const eventHandlers = {
        submit: async (data) =>
        {
            const formData = new FormData();
            formData.append('ticketId', ticket.id);
            formData.append('comment', data.comment);
            if(data.file1) formData.append('file1', data.file1);
            if(data.file2) formData.append('file2', data.file2);
            if(data.file3) formData.append('file3', data.file3);

            let [error, response] = await handleRequest(ticketApi.addComment(formData));

            let message = apiError(`Trả lời ticket thất bại`, error, response);

            if (!message)
            {
                setComments([
                    ...comments,
                    response.data,
                ])

                reset(initialValues)
            }
        }
    }

    return (
        <form className="form mt-3" onSubmit={handleSubmit(eventHandlers.submit)}>
            {isSubmitting && <Loading/>}
            <Controller control={control} name="comment" render={({ field }) => (
                <EditorField height={200} errors={errors} {...field}/>
            )}/>
            <p className="heading">File đính kèm</p>
            <Row>
                <Col span={8}>
                    <Controller control={control} name="file1" render={({field}) => (
                        <InputField
                            label="Tệp đính kèm"
                            type="file"
                            errors={errors}
                            onChange={(e) => {
                                field.onChange(e.target.files[0]); // chỉ lấy 1 file
                            }}
                        />
                    )}/>
                </Col>
                <Col span={8}>
                    <Controller control={control} name="file2" render={({field}) => (
                        <InputField
                            label="Tệp đính kèm"
                            type="file"
                            errors={errors}
                            onChange={(e) => {
                                field.onChange(e.target.files[0]); // chỉ lấy 1 file
                            }}
                        />
                    )}/>
                </Col>
                <Col span={8}>
                    <Controller control={control} name="file3" render={({field}) => (
                        <InputField
                            label="Tệp đính kèm"
                            type="file"
                            errors={errors}
                            onChange={(e) => {
                                field.onChange(e.target.files[0]); // chỉ lấy 1 file
                            }}
                        />
                    )}/>
                </Col>
            </Row>

            <hr />
            <div className="form-group">
                <Button primary type="submit">Tạo câu trả lời</Button>
            </div>
        </form>
    )
}

export default TicketFormComment;